import { ITreeNode } from "@/services/objective-manager";
import { Icon } from "ant-design-vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import { DegreeType } from "@/util/enum";
import { ReportsModule } from "@/modules/reports-objective";
import BasicIcon from "@/style/svgs/basic.svg";
import ExpertIcon from "@/style/svgs/expert.svg";
import MiddleIcon from "@/style/svgs/middle.svg";

@Component({
	components: {
		Icon,
		BasicIcon,
		MiddleIcon,
		ExpertIcon
	}
})
export default class UnitDegree extends Vue {
	private ReportsModule = ReportsModule;
	public DegreeType = DegreeType;
	@Prop() recorder?: ITreeNode;
	@Prop() degree?: number;

	get basicComp() {
		return BasicIcon;
	}
	get middleComp() {
		return MiddleIcon;
	}
	get expertComp() {
		return ExpertIcon;
	}

	getDegreeComponent() {
		switch (this.degree) {
			case DegreeType.Basic:
				return this.basicComp;
			case DegreeType.Intermediate:
				return this.middleComp;
			case DegreeType.Expert:
				return this.expertComp;
			default:
				return null;
		}
	}
}
